import React from 'react';
import PenIcon from '@/customercenter-ui/icons/pen';

type PersonalizeProps = {
  personalizeText?: string;
  className?: string;
};

const Personalize: React.FC<PersonalizeProps> = ({ personalizeText }: PersonalizeProps) => (
  <section className="mb-5 mr-3 rounded-md border-2 border-foggyGray bg-lightSilver pl-3 pr-2 pt-3 shadow-md">
    <section className="flex flex-row gap-4">
      <section>
        <PenIcon />
      </section>
      <section className="pb-3 text-base">
        <span className="font-bold">Personalization: </span>
        <span className="gbmask">{personalizeText ?? 'Default placeholder'}</span>
      </section>
    </section>
  </section>
);

export default Personalize;
